import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Index from './pages/one-page';
import ProtectedRoute from './hooks/auth/useAuthWrapper';
import Dashboard from './pages/admin/admin';
import DashboardLayout from './layout/admin/dashboard-layout';
import Support from './pages/admin/support';
import Login from './pages/admin/login';
import './styles/index.scss';
import NotFound from './pages/404';
import Uploads from './pages/admin/uploads';
import Settings from './pages/admin/setting';
import Installations from './pages/installations';
import InstallationDetails from './pages/installations-details';
import Products from './pages/admin/products';
import Policy from './pages/policy';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/installatie-voorbeelden" element={<Installations />} />
        <Route path="/installatie-voorbeelden/:id" element={<InstallationDetails />} />
        <Route path="/voorwaarden" element={<Policy />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="support" element={<Support />} />
          <Route path="gallery" element={<Uploads />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
